export const getMessages = (state) => {
    return state.constructs.messages;
}

export const getMessageList = (state) => {
    const list = state.constructs.messages.map(item => {
        return {label: item.name, value: item.id}
    })
    const alphabeticallyArrangedList = list.sort(function (a, b) {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      })
    return alphabeticallyArrangedList;
}